import { LinearProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useContext } from "react"
import LabsContext, { LabsContainer } from "~/contexts/Labs"
import Page from "~/pages/Page"
import Router from "~/router"

import usePermissionsRedirect from "~/hooks/usePermissionsRedirect"
import useStyles from "./styles"

const Labs = ({ routes = [], ...rest }) => {
  const classes = useStyles()
  usePermissionsRedirect("/learning-paths", "labs")

  return (
    <Page>
      <LabsContainer>
        <LabsWrapper>
          <Router routes={routes} {...rest} />
        </LabsWrapper>
      </LabsContainer>
    </Page>
  )
}

Labs.propTypes = {
  routes: PropTypes.array,
}

const LabsWrapper = ({ children }) => {
  const { labsLoading } = useContext(LabsContext)
  if (labsLoading) {
    return <LinearProgress />
  } else {
    return children
  }
}

LabsWrapper.propTypes = {
  children: PropTypes.node,
}

export default Labs
